<template>
  <div v-if="visible" class="checkout-overlay">
    <div class="checkout-overlay__content">
      <p class="checkout-overlay__text">
        {{ getWarningMessage }}
      </p>
      <button class="link-button" @click="submitPayment">        
        {{ getClickToContinueMessage }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean, // Controls the visibility of the overlay,
    submitPayment: Function
  },
  computed: {
    getWarningMessage() {
      return (
        this.$store.getters.get_text(
          "inapp_portal.info.come_back_after_authorise"
        ) ||
        this.$store.getters.get_text(
          "inapp_checkout.info.come_back_after_authorise"
        ) ||
        this.$store.getters.get_text(
          "paynow.info.come_back_after_authorise"
        )
      );
    },
    getClickToContinueMessage() {
      return (
        this.$store.getters.get_text(
          "inapp_portal.info.click_to_continue"
        ) ||
        this.$store.getters.get_text(
          "inapp_checkout.info.click_to_continue"
        ) ||
        this.$store.getters.get_text(
          "paynow.info.click_to_continue"
        )
      );
    }
  }
};
</script>

<style scoped>
.checkout-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.checkout-overlay__content {
  /* background: white; */
  padding: 20px;
  border-radius: 10px;
  font-size: 18px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 90%; /* Ensures it doesn't exceed screen width */
}

.checkout-overlay__text {
  white-space: normal;
  word-break: break-word;
  max-width: 90%;
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  color: white;
  text-align: center;
  font-weight: bold;
}

/* Responsive max-width adjustments */
@media (min-width: 768px) {
  .checkout-overlay__text {
    max-width: 60%;
  }
}

@media (min-width: 1024px) {
  .checkout-overlay__text {
    max-width: 50%;
  }
}

.link-button {
  background: none;
  border: none;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
  padding: 40px;
  font-weight: bold;
  color: white;
}
</style>
